import React from 'react'
import { COLORS } from '../theme'

// Cell styling and the sortable header, shared by the board's two tables.
//
// These lived inside DevTable's function body, which meant a second table could
// only reach them by having them passed in as props — two peer components
// handing each other inline style objects. They are pure (COLORS only), so they
// are constants, and the duplicated sort-button markup is one component now
// rather than two copies drifting apart.

export const TH = {
    textAlign: 'left',
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: COLORS.textMuted,
    padding: '0 8px 6px 0',
    borderBottom: `1px solid ${COLORS.border}`,
    whiteSpace: 'nowrap',
}

export const TD = {
    padding: '7px 8px 7px 0',
    borderBottom: `1px solid ${COLORS.border}33`,
    fontSize: 13,
    color: COLORS.text,
    verticalAlign: 'middle',
}

export function SortHeader({ label, active, onClick, title }) {
    return (
        <button
            onClick={onClick}
            title={title}
            style={{
                background: 'none',
                border: 'none',
                padding: 0,
                font: 'inherit',
                cursor: 'pointer',
                color: active ? COLORS.primary : COLORS.textMuted,
                fontWeight: 700,
                textDecoration: active ? 'underline' : 'none',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                fontSize: 10.5,
            }}
        >
            {label}
        </button>
    )
}
